import { useState } from "react";
import { useCustomImage } from "../hooks";

export type ImageType = {
  src: string;
  localized?: boolean;
  alt?: string;
  style?: any;
};

const Image: React.FC<ImageType> = ({
  src,
  localized,
  alt = "",
  style = {},
}) => {
  const [hadError, setHadError] = useState(false);
  const [localizedSrc, setLocalizedSrc] = useState(
    useCustomImage(src, localized)
  );
  const fallback = useCustomImage(src);
  const onError = () => {
    if (hadError || !localized) return;

    setLocalizedSrc(fallback);
    setHadError(true);
  };

  if (!src) return null;

  return <img src={localizedSrc} onError={onError} alt={alt} style={style} />;
};

export default Image;
